import { render, staticRenderFns } from "./custom-business-185.vue?vue&type=template&id=6a200fcb&scoped=true"
import script from "./custom-business-185.vue?vue&type=script&lang=js"
export * from "./custom-business-185.vue?vue&type=script&lang=js"
import style0 from "./custom-business-185.vue?vue&type=style&index=0&id=6a200fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a200fcb",
  null
  
)

export default component.exports